import { HTTP } from '../../http';
import router from '../../router/index';

const state = {
  chosenBatteries: JSON.parse(localStorage.getItem('exideQuoteBatteries')) || []
};

const mutations = {
  addToChosenBatteries: (state, battery) => {
    if (state.chosenBatteries.length < 3) {
      state.chosenBatteries.push(battery);
      localStorage.setItem('exideQuoteBatteries', JSON.stringify(state.chosenBatteries));
    }
  },
  removeFromChosenBatteries: (state, battery) => {
    state.chosenBatteries = state.chosenBatteries.filter(chosen => chosen.id !== battery.id);
    localStorage.setItem('exideQuoteBatteries', JSON.stringify(state.chosenBatteries));
  },
  setChosenBatteries: (state, array) => {
    state.chosenBatteries = [];
  }
};

const getters = {
  getChosenBatterries: state => state.chosenBatteries
};

const actions = {};

export default {
  state,
  mutations,
  getters,
  actions
};
